<script>
import { icon } from '@fortawesome/fontawesome-svg-core'

var icons = {
  flag: icon({ iconName:'flag' }).abstract[0].children[0]
}

export default {
  name: 'area-point',
  render (createElement) {
    return createElement('g', {
      attrs:{ id:this.value },
      class:'area-point',      
      style:`transform: matrix(1,0,0,1,${this.x},${this.y})`
    },[
      createElement('g', {
        class:'mark',
        style:`transform: matrix(0.1,0,0,0.1,-10,-50)`,
        on:{
          click: ()=>{ this.$emit('click',this.value) },
          touchend: ()=>{ this.$emit('click',this.value) },
        }
      },[
        //flag icon
        createElement('path', {
          attrs: icons.flag.attributes
        })
      ]),
      createElement('text', {
        attrs:{ x:0, y:30, 'text-anchor':'middle', fill:'black' }
      },[
        `${this.label}(Lv${this.lv})`
      ])
    ])
  },
  props: {
    x: Number,
    y: Number,
    label: String,
    value: String,
    lv: Number
  },
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.mark {
  cursor: pointer;
}
</style>
